import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Rush = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.887 6.112C23.224 3.462 19.712 2 16 2C11.125 2 6.71299 4.412 4.17499 8.438L4.14999 8.475C4.04999 8.625 3.99999 8.813 3.99999 9C3.99999 9.55 4.44999 10 4.99999 10C5.34999 10 5.66199 9.812 5.83799 9.537C8.01299 6.062 11.813 4 16 4C19.188 4 22.188 5.25 24.462 7.537C26.75 9.812 28 12.812 28 16C28 19.188 26.75 22.188 24.462 24.462C22.187 26.75 19.187 28 15.999 28C11.811 28 8.01199 25.937 5.84899 22.475C5.67399 22.187 5.36199 22 4.99899 22C4.44899 22 3.99899 22.45 3.99899 23C3.99899 23.2 4.06199 23.375 4.14899 23.525C4.14899 23.525 4.16199 23.55 4.17399 23.55C6.71099 27.588 11.124 30 15.999 30C19.712 30 23.224 28.538 25.886 25.887C28.548 23.236 29.999 19.712 29.999 16C29.999 12.288 28.537 8.775 25.886 6.113L25.887 6.112Z" />
		<path d="M7 18H9C9.55 18 10 18.45 10 19C10 19.55 9.55 20 9 20H7C6.45 20 6 19.55 6 19C6 18.45 6.45 18 7 18Z" />
		<path d="M4 19C4 19.552 3.552 20 3 20C2.448 20 2 19.552 2 19C2 18.448 2.448 18 3 18C3.552 18 4 18.448 4 19Z" />
		<path d="M9 14H3C2.45 14 2 13.55 2 13C2 12.45 2.45 12 3 12H9C9.55 12 10 12.45 10 13C10 13.55 9.55 14 9 14Z" />
		<path d="M21.712 20.288L17 15.588V9C17 8.45 16.55 8 16 8C15.45 8 15 8.45 15 9V16C15 16.262 15.1 16.525 15.287 16.712L20.287 21.712C20.462 21.887 20.712 22 20.999 22C21.549 22 21.999 21.55 21.999 21C21.999 20.725 21.886 20.475 21.711 20.288H21.712Z" />
	</svg>
);

export default Rush;
